import React from "react";

const ComplianceDocumentsModal = ({ isOpen, onClose, documents }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-30">
            <div className="bg-white p-6 rounded-lg w-full max-w-2xl max-h-[80vh] overflow-y-auto">
                <h2 className="text-xl font-semibold mb-4">Compliance Documents</h2>

                {documents?.length === 0 ? (
                    <p className="text-gray-500">No compliance documents uploaded.</p>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {documents?.map((doc) => (
                            <div key={doc.id} className="border rounded-lg p-4 shadow-sm">
                                <p className="font-medium">{doc.type}</p>
                                <p className="text-sm text-gray-500">
                                    Uploaded: {new Date(doc.uploadedDate).toLocaleDateString()}
                                </p>
                                <a
                                    href={doc.fileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-2 inline-block text-blue-600 hover:underline text-sm"
                                >
                                    View Document
                                </a>
                            </div>
                        ))}
                    </div>
                )}

                <div className="mt-6 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ComplianceDocumentsModal;
